import {getEndpoint, getHeaders} from '../../helpers/endpoint';
import swal from 'sweetalert2';

export const REQUEST_GET_UBER_EATS_WINNERS = 'REQUEST_GET_UBER_EATS_WINNERS';
export const SUCCESS_GET_UBER_EATS_WINNERS = 'SUCCESS_GET_UBER_EATS_WINNERS';
export const FAIL_GET_UBER_EATS_WINNERS = 'FAIL_GET_UBER_EATS_WINNERS';

export const getUberEatsWinners = (onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_WINNERS});

    return fetch(getEndpoint('getUberEatsWinners'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_WINNERS,
            error: data.error,
          });
        } else dispatch(successGetUberEatsWinners(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_WINNERS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsWinners(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_WINNERS,
      list: response,
    });
  };
}

export const REQUEST_GET_UBER_EATS_GAME = 'REQUEST_GET_UBER_EATS_GAME';
export const SUCCESS_GET_UBER_EATS_GAME = 'SUCCESS_GET_UBER_EATS_GAME';
export const FAIL_GET_UBER_EATS_GAME = 'FAIL_GET_UBER_EATS_GAME';

export const getUberEatsGame = (onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_GAME});

    return fetch(getEndpoint('getUberEatsGame'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_GAME,
            error: data.error,
          });
        } else dispatch(successGetUberEatsGame(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_GAME) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsGame(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_GAME,
      list: response,
    });
  };
}

export const REQUEST_UPDATE_UBER_EATS_GAME = 'REQUEST_UPDATE_UBER_EATS_GAME';
export const SUCCESS_UPDATE_UBER_EATS_GAME = 'SUCCESS_UPDATE_UBER_EATS_GAME';
export const FAIL_UPDATE_UBER_EATS_GAME = 'FAIL_UPDATE_UBER_EATS_GAME';

export const updateUberEatsGame = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_UBER_EATS_GAME, payload, scope});

    fetch(getEndpoint('updateUberEatsGame', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.error}<br/>`,
          });
          dispatch({
            type: FAIL_UPDATE_UBER_EATS_GAME,
            error: data.error,
            payload,
            scope,
          });
        } else dispatch(successUpdateUberEatsGame(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_UBER_EATS_GAME) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateUberEatsGame(response, payload, scope) {
  return {
    type: SUCCESS_UPDATE_UBER_EATS_GAME,
    receivedAt: Date.now(),
    success: response.success,
    payload,
    scope,
  };
}

export const REQUEST_UPDATE_UBER_EATS_WINNERS =
  'REQUEST_UPDATE_UBER_EATS_WINNERS';
export const SUCCESS_UPDATE_UBER_EATS_WINNERS =
  'SUCCESS_UPDATE_UBER_EATS_WINNERS';
export const FAIL_UPDATE_UBER_EATS_WINNERS = 'FAIL_UPDATE_UBER_EATS_WINNERS';

export const updateUberEatsWinners = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_UBER_EATS_WINNERS, payload, scope});

    fetch(getEndpoint('updateUberEatsWinners', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.error}<br/>`,
          });
          dispatch({
            type: FAIL_UPDATE_UBER_EATS_WINNERS,
            error: data.error,
            payload,
            scope,
          });
        } else dispatch(successUpdateUberEatsWinners(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_UBER_EATS_WINNERS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateUberEatsWinners(response, payload, scope) {
  return {
    type: SUCCESS_UPDATE_UBER_EATS_WINNERS,
    receivedAt: Date.now(),
    success: response.success,
    payload,
    scope,
  };
}

export const REQUEST_GET_UBER_EATS_USERS_BY_DAY =
  'REQUEST_GET_UBER_EATS_USERS_BY_DAY';
export const SUCCESS_GET_UBER_EATS_USERS_BY_DAY =
  'SUCCESS_GET_UBER_EATS_USERS_BY_DAY';
export const FAIL_GET_UBER_EATS_USERS_BY_DAY =
  'FAIL_GET_UBER_EATS_USERS_BY_DAY';

export const getUberEatsUsersByDay = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_USERS_BY_DAY});

    return fetch(getEndpoint('getUberEatsUsersByDay', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_USERS_BY_DAY,
            error: data.error,
          });
        } else dispatch(successGetUberEatsUsersByDay(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_USERS_BY_DAY) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsUsersByDay(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_USERS_BY_DAY,
      list: response,
    });
  };
}

export const REQUEST_GET_UBER_EATS_USERS_BY_GAME_WEEK =
  'REQUEST_GET_UBER_EATS_USERS_BY_GAME_WEEK';
export const SUCCESS_GET_UBER_EATS_USERS_BY_GAME_WEEK =
  'SUCCESS_GET_UBER_EATS_USERS_BY_GAME_WEEK';
export const FAIL_GET_UBER_EATS_USERS_BY_GAME_WEEK =
  'FAIL_GET_UBER_EATS_USERS_BY_GAME_WEEK';

export const getUberEatsUsersByGameWeek = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_USERS_BY_GAME_WEEK});

    return fetch(getEndpoint('getUberEatsUsersByGameWeek', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_USERS_BY_GAME_WEEK,
            error: data.error,
          });
        } else dispatch(successGetUberEatsUsersByGameWeek(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_USERS_BY_GAME_WEEK) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsUsersByGameWeek(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_USERS_BY_GAME_WEEK,
      list: response,
    });
  };
}

export const REQUEST_GET_UBER_EATS_USERS_RESULTS =
  'REQUEST_GET_UBER_EATS_USERS_RESULTS';
export const SUCCESS_GET_UBER_EATS_USERS_RESULTS =
  'SUCCESS_GET_UBER_EATS_USERS_RESULTS';
export const FAIL_GET_UBER_EATS_USERS_RESULTS =
  'FAIL_GET_UBER_EATS_USERS_RESULTS';

export const getUberEatsUsersResults = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_USERS_RESULTS});

    return fetch(getEndpoint('getUberEatsUsersResults', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_USERS_RESULTS,
            error: data.error,
          });
        } else dispatch(successGetUberEatsUsersResults(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_USERS_RESULTS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsUsersResults(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_USERS_RESULTS,
      list: response,
    });
  };
}

export const REQUEST_GET_UBER_EATS_USERS_SECONDARY_WINNERS =
  'REQUEST_GET_UBER_EATS_USERS_SECONDARY_WINNERS';
export const SUCCESS_GET_UBER_EATS_USERS_SECONDARY_WINNERS =
  'SUCCESS_GET_UBER_EATS_USERS_SECONDARY_WINNERS';
export const FAIL_GET_UBER_EATS_USERS_SECONDARY_WINNERS =
  'FAIL_GET_UBER_EATS_USERS_SECONDARY_WINNERS';

export const getUberEatsUsersSecondaryWinners = (
  payload,
  onSuccess,
  onError,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_USERS_SECONDARY_WINNERS});

    return fetch(getEndpoint('getUberEatsUsersSecondaryWinners', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_USERS_SECONDARY_WINNERS,
            error: data.error,
          });
        } else
          dispatch(successGetUberEatsUsersSecondaryWinners(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_USERS_SECONDARY_WINNERS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsUsersSecondaryWinners(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_USERS_SECONDARY_WINNERS,
      list: response,
    });
  };
}

export const REQUEST_GET_UBER_EATS_CONFIG = 'REQUEST_GET_UBER_EATS_CONFIG';
export const SUCCESS_GET_UBER_EATS_CONFIG = 'SUCCESS_GET_UBER_EATS_CONFIG';
export const FAIL_GET_UBER_EATS_CONFIG = 'FAIL_GET_UBER_EATS_CONFIG';

export const getUberEatsConfig = (onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_UBER_EATS_CONFIG});

    return fetch(getEndpoint('getUberEatsConfig'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_UBER_EATS_CONFIG,
            error: data.error,
          });
        } else dispatch(successGetUberEatsConfig(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_UBER_EATS_CONFIG) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUberEatsConfig(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_UBER_EATS_CONFIG,
      list: response,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/uberEats.js